var image_viewer_rtlignore_default = {
  "fontElementMap": "_0EoTx",
  "imageContainer": "VNeeD",
  "expandButton": "ZWWBG",
  "expandIcon": "ylExO",
  "pointer": "KnSpt",
  "imageWrapper": "qiXex",
  "imageRatio": "jjsJu",
  "image": "mzx22",
  "imageOverlay": "qblxf",
  "imagePreload": "ZikCc",
  "imageHighres": "miH8m",
  "onlyHighRes": "GTgwu",
  "image_loading": "bn5Av"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
